import React, {Component} from 'react';
import _ from 'lodash';

import connect from 'react-redux/es/connect/connect';
import {bindActionCreators} from 'redux';
import '../../styles/App.scss';
import '../../styles/EntityDetails.css';
import '../../styles/NewEntityDetails.css';
import '../../styles/Global.css';

import * as entityActions from '../../actions/entity';
import {uploadDoc, verifyDoc, clearIndiviualInfo, fetchIndiviualInfo} from '../../actions/kyc';
import {
    startKycMaintenance,
    onChangeValue,
    onDirChangeValue,
    setEntity,
    onNewDoc,
    saveKYC,
    completeKYC,
    onNewRelatedParty,
    onRemoveRelatedParty,
    onNewAuthorisedPerson,
    onRemoveAuthorisedPerson,
    kycSaved,
    onAddressChangeValue,
    addOwner,
    pip,
    updatePips,
    updateController
} from '../../actions/kycMaintenance';
import {clearEntityInfo, removeSearched} from '../../actions/entity';
import validate from 'validate.js';
import FormField from '../formField/FormField';
import DocumentViewer from '../DocumentViewer';
import Popup from '../Popup';
import AuthorisedPersonsComponent from './AuthorisedPersonsComponent';
import Alert from 'react-bootstrap/es/Alert';
import Button from 'react-bootstrap/es/Button';
import RelatedPartiesNew from './RelatedPartiesNew';
import Col from 'react-bootstrap/lib/Col';
import AdditionalQuestions from './AdditionalQuestions';
import Modal from 'react-bootstrap/lib/Modal';
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup';


const DOC_TYPES = {
    proofOfId: 'Proof of Identity',
    proofOfAddress: 'Proof Of Address'
};

class KycMaintenance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            validationErrors: [],
            submitting: false,
            submittingError: null,
        };

    }

    handleEntityInfoChange = ({target}) => {
        const {actions} = this.props;
        const {name, value} = target;
        actions.onChangeValue(name, value);
    };

    handleAddressChange = ({target}, changingAddress) => {
        const {actions} = this.props;
        const {name, value} = target;
        changingAddress[name] = value;
        actions.onAddressChangeValue('', 'addresses', changingAddress);
    };

    handleDirectorAddressChoice = (selectedDirector, value) => {
        const {actions, kyc: {kycRequest: {directors}}} = this.props;
        const director = directors[selectedDirector];
        const {addresses} = director;
        director.address = addresses[value];
        actions.onDirChangeValue('', 'directors', director);
    };

    handleDirectorChange = (selectedDirector, item, value) => {
        const {actions, kyc: {kycRequest: {directors}}} = this.props;
        const director = directors[selectedDirector];
        director[item] = value;
        actions.onDirChangeValue('', 'directors', director);
    };

    handlePipChange = (pipChange) => {
        const {actions} = this.props;
        actions.pip(pipChange);
    };
    handlePipsUpdate = (pipChange) => {
        const {actions} = this.props;
        actions.updatePips(pipChange);
    };
    handleControlChange = (controllerChange) => {
        const {actions} = this.props;
        actions.updateController(controllerChange);
    };

    handleDirectorAddressChange = (selectedDirector, person) => {
        const {actions, kyc: {kycRequest: {directors}}} = this.props;
        // const director = directors[selectedDirector];
        // director.address = address;

        actions.onDirChangeValue('', selectedDirector, person);
    };

    handleRelatedPartyAddressChange = (selectedRelatedParty, changedAddress) => {
        const {actions, kyc: {kycRequest: {children}}} = this.props;
        const relatedParty = children[selectedRelatedParty];
        relatedParty.address = changedAddress;
        actions.onDirChangeValue('', 'children', relatedParty);
    };

    handleRelatedPartyChange = ({target}, selectedRelatedParty) => {
        const {actions, kyc: {kycRequest: {children}}} = this.props;
        const relatedParty = children[selectedRelatedParty];
        const {name, value} = target;
        relatedParty[name] = value;
        actions.onDirChangeValue("", "children", relatedParty);
    };

    handleAddRelatedParty = (relatedParty) => {
        const {actions} = this.props;
        actions.onNewRelatedParty(relatedParty);
    };
    handleAddOwner = (updatedChild) => {
        const {actions} = this.props;
        actions.addOwner(updatedChild);
    };
    handleAddAuthorisedPerson = async (authorisedPerson) => {
        const {actions} = this.props;
        await actions.onNewAuthorisedPerson(authorisedPerson);
        this.onHandleSave();
    };

    handleRemoveRelatedParty = (relatedParty) => {
        const {actions} = this.props;
        actions.onRemoveRelatedParty(relatedParty);
    };
    handleRemoveAP = (authorisedPerson) => {
        const {actions} = this.props;
        actions.onRemoveAuthorisedPerson(authorisedPerson);
    };

    _findDoc = (entityDocs, documentType) => {
        const docFound = _.find(entityDocs, (doc) => (doc.type === documentType));
        return docFound ? docFound : {type: documentType, isNew: true}
    };
    _findAddress = (addresses, addressType) => {
        const addressFound = _.find(addresses, (address) => (address.type === addressType));
        return addressFound ? addressFound : {type: addressType}
    };

    onHandleUpload = (base64, inProgress, onComplete, onSuccess) => {
        const {actions} = this.props;
        const {selectedDocument} = this.state;
        const handleOnSuccess = (documentId) => {
            selectedDocument.isUpload = true;
            selectedDocument.updated = true;
            selectedDocument.id = documentId;
            this.setState({selectedDocument});
            onSuccess && onSuccess(documentId);
        };
        actions.uploadDoc(base64, handleOnSuccess, null, inProgress, onComplete)
    };
    onHandleVerify = () => {
        const {actions} = this.props;
        const {document, selectedDocument} = this.state;
        if (document.externalId || selectedDocument.id) {
            if (selectedDocument.isUpload)
                document.externalId = selectedDocument.id;
            document.verified = true;
            if (document.name) {
                actions.onDirChangeValue("", "documents", document);
            } else {
                actions.onNewDoc(document);
            }
            this.setState({
                selectedDocument: null,
                document: null
            })
        }
    };

    onHandleSave = () => {
        const {kyc: {id, kycRequest}, actions} = this.props;
        actions.saveKYC(id, kycRequest);
    };
    onHandleSaveContinue = () => {
        const {kyc: {id, kycRequest}, actions, history} = this.props;
        actions.saveKYC(id, kycRequest, history, true);
    };

    completeKYC = () => {
        const {kyc: {kycRequest}} = this.props;
        let validationErrors = [];
        const {directors, children} = kycRequest;
        children.forEach(relatedParty => {
            const empty = KycMaintenance.checkRelatedPartyAddress(relatedParty);
            empty && validationErrors.push(
                <span>Please complete an address for <strong>"{relatedParty.name}"</strong></span>);
        });
        directors.forEach(director => {
            const empty = KycMaintenance.checkAuthorisedAddress(director);
            empty && validationErrors.push(
                <span>Please complete/choose an address for <strong>"{director.firstName} {director.lastName}"</strong></span>);
        });
        let checker = this.checkDocument('Ownership Structure', kycRequest);
        checker && validationErrors.push(checker);
        checker = this.checkDocument('Resolution', kycRequest);
        checker && validationErrors.push(checker);
        checker = this.checkDocument('CIPC Document', kycRequest);
        checker && validationErrors.push(checker);
        checker = this.checkEntityAddress(kycRequest, 'Principal');
        checker && validationErrors.unshift(checker);
        checker = this.checkEntityAddress(kycRequest, 'Trading');
        checker && validationErrors.unshift(checker);
        validationErrors = KycMaintenance.checkEntityDetails(kycRequest, validationErrors);
        validationErrors.length > 0 ? this.setState({validationErrors}) : this.setState({submitting: true});
    };

    validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    submitReview = () => {
        const {kyc: {id, kycRequest}, actions, history} = this.props;
        const onSuccess = () => {
            actions.kycSaved();
        };
        this.setState({submittingError: null});
        if (this.validateEmail(kycRequest.contactEmail)) {
            this.setState({submitting: false})
            actions.completeKYC(id, kycRequest, history);
        } else {
            this.setState({submittingError: (<span>Please enter a valid <strong>email address</strong>.</span>)})
        }

    }

    checkEntityAddress({addresses}, addressType) {
        const address = this._findAddress(addresses, addressType);
        const {crcCountryId, zipCode, crcRegionId, crcCityId, suburb, streetAddressLine1} = address;
        const check1 = (crcCountryId && zipCode && crcRegionId);
        const check2 = (crcCityId && suburb && streetAddressLine1);
        return !(check1 && check2)
            ? <span>Complete <strong>{addressType} address</strong>.</span> : null;
    }

    static checkRelatedPartyAddress({address}) {
        if (!address || _.isEmpty(address))
            return true;
        const {crcCountryId, zipCode, crcRegionId, crcCityId, suburb, streetAddressLine1} = address;
        return !(crcCountryId && zipCode && crcRegionId && crcCityId && suburb && streetAddressLine1);
    }

    static checkAuthorisedAddress({address}) {
        if (!address || _.isEmpty(address))
            return true;
        const {line1, line2, line3, postalCode} = address;
        return !(line1 && line2 && line3 && postalCode);
    }

    static checkEntityDetails({name, telephoneNumber, sourceOfIncome, pip, pips, controllers}, validationErrors) {
        _.isEmpty(name) &&
        validationErrors.unshift(<span><strong>Registered Name</strong> cannot be empty!</span>);
        _.isEmpty(telephoneNumber) &&
        validationErrors.unshift(<span><strong>Telephone Number</strong> cannot be empty!</span>);
        _.isEmpty(sourceOfIncome) &&
        validationErrors.unshift(<span><strong>Source of Income</strong> cannot be empty!</span>);
        typeof pip !== 'boolean' &&
        validationErrors.unshift(
            <span>Please verify if any of the authorised/controlling persons
                    either a public official in a position of authority or
                    related/associated to a public official in a position of authority?.</span>);
        pip && _.isEmpty(pips) &&
        validationErrors.unshift(<span>Please add the authorised/controlling persons
                    either a public official in a position of authority or
                    related/associated to a public official in a position of authority</span>);
        _.isEmpty(controllers) &&
        validationErrors.unshift(<span>Please add entity <strong>Controllers</strong>.</span>);
        return validationErrors;
    }

    checkDocument(type, {documents}) {
        const document = this._findDoc(documents, type);
        return document.verified ? null : (<span>Please upload/verify  <strong>"{type} Document"</strong></span>);
    }

    onHandleRemoveDocument = (documentType) => {
        const {onRemoveDocument} = this.props;
        onRemoveDocument && onRemoveDocument(documentType);
    };

    handleResetError = (attribute) => {
        const {errors} = this.state;
        this.setState({errors: _.extend({}, errors, {[attribute]: null})})
    };

    validateDocs = () => {
        const {entityDocs} = this.state;
        const options = {fullMessages: false};

        const checkDocument = (documentType) => {
            const doc = this._findDoc(entityDocs, documentType);
            return doc && doc.verified ? doc : null;
        };

        const constraints = {
            [DOC_TYPES.resolution]: {presence: true},
            [DOC_TYPES.cpicDocument]: {presence: true},
            [DOC_TYPES.ownershipStructure]: {presence: true},
        };
        const errors = validate({
            [DOC_TYPES.resolution]: checkDocument(DOC_TYPES.resolution),
            [DOC_TYPES.cpicDocument]: checkDocument(DOC_TYPES.cpicDocument),
            [DOC_TYPES.ownershipStructure]: checkDocument(DOC_TYPES.ownershipStructure),

        }, constraints, options);
        this.setState({errors});
        return _.isEmpty(errors);
    };


    handleViewDocument = (selectedDocument, available = true) => {
        const {errors} = this.state;
        errors && errors.selectedDocument && this.handleResetError('selectedDocument');
        if (available) {
            this.setState({
                selectedDocument: {
                    id: selectedDocument.externalId,
                    type: selectedDocument.type
                },
                document: selectedDocument
            });
        } else {
            this.setState({
                selectedDocument: {
                    id: null,
                    type: selectedDocument.type
                },
                document: selectedDocument
            });
        }

    }

    renderEntityDetails = () => {
        const {errors} = this.state;
        const {kyc: {kycRequest}} = this.props;
        const principalAddress = this._findAddress(kycRequest.addresses, 'Principal');
        const tradingAddress = this._findAddress(kycRequest.addresses, 'Trading');

        return (
            <div className="col-md-12">

                    <div className="col-md-6">
                        <FormField className="form-group">
                            <label htmlFor="tradingAs">Trading As</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tradingAs"
                                name='tradingAs'
                                value={kycRequest.tradingAs ? kycRequest.tradingAs : ''}
                                    onChange={(event) => this.handleEntityInfoChange(event)}
                                />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField className="form-group" id="regName" error={errors && errors.name}>
                                <label htmlFor="name">Registered Name <span
                                    className='text-danger'>*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name='name'
                                    value={kycRequest.name ? kycRequest.name : ""}
                                    onChange={(event) => {
                                        errors && errors.name && onResetError && onResetError('name');
                                        this.handleEntityInfoChange(event);
                                    }}
                                />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField className="form-group">
                                <label htmlFor="vatNumber">VAT Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="vatNumber"
                                    name='vatNumber'
                                    value={kycRequest.vatNumber ? kycRequest.vatNumber : ""}
                                    onChange={(event) => this.handleEntityInfoChange(event)}
                                />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField className="form-group">
                                <label htmlFor="telephoneNumber">Telephone Number <span className='text-danger'>*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="telephoneNumber"
                                    name='telephoneNumber'
                                    value={kycRequest.telephoneNumber ? kycRequest.telephoneNumber : ""}
                                    onChange={(event) => this.handleEntityInfoChange(event)}
                                />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField className="form-group" id="sourceOfFunds" error={errors && errors.SOF}>
                                <label htmlFor="sourceOfFunds">Source of Funds</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name='sourceOfFunds'
                                    id="sourceOfFunds" disabled={true} readOnly={true}
                                    value={kycRequest.sourceOfFunds ? kycRequest.sourceOfFunds : ""}
                                />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField className="form-group" id="sourceOfIncome" error={errors && errors.SOI}>
                                <label htmlFor="sourceOfIncome">Source of Income <span className='text-danger'>*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="sourceOfIncome"
                                    name='sourceOfIncome'
                                    onChange={e => this.handleEntityInfoChange(e)}
                                    value={kycRequest.sourceOfIncome ? kycRequest.sourceOfIncome : ""}
                                />
                            </FormField>
                        </div>

                    <div className="col-md-6">
                        <div className="section-title">
                            <span>Primary Address <span className='text-danger'>*</span></span>
                        </div>

                        <FormField className="form-group" id="regAddress" error={errors && errors.street}>
                            <label htmlFor="registeredAddressLin1">Address</label>
                            <input
                                className="form-control"
                                id="registeredAddressLine1"
                                name='streetAddressLine1'
                                onChange={(event) => {
                                    errors && errors.street && onResetError && onResetError('street');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                                type="text"
                                value={principalAddress.streetAddressLine1 ? principalAddress.streetAddressLine1 : ""}

                            />
                        </FormField>

                        <FormField className="form-group" id="line2" error={errors && errors.suburb}>
                            <label htmlFor="registeredAddressLine2">Suburb</label>
                            <input
                                className="form-control"
                                id="registeredAddressLine2"
                                name='suburb'
                                onChange={(event) => {
                                    errors && errors.suburb && onResetError && onResetError('suburb');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                                type="text"
                                value={principalAddress.suburb ? principalAddress.suburb : ""}
                            />
                        </FormField>

                        <FormField className="form-group" id="regCity" error={errors && errors.city}>
                            <label htmlFor="registeredCity">City</label>
                            <input
                                type="text"
                                className="form-control"
                                id="registeredCity"
                                name='crcCityId'
                                value={principalAddress.crcCityId ? principalAddress.crcCityId : ""}
                                onChange={(event) => {
                                    errors && errors.city && onResetError && onResetError('city');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regProvince" error={errors && errors.province}>
                            <label htmlFor="stateOrProvince">State/Province</label>
                            <input
                                type="text"
                                className="form-control"
                                id="stateOrProvince"
                                name='crcRegionId'
                                value={principalAddress.crcRegionId ? principalAddress.crcRegionId : ""}
                                onChange={(event) => {
                                    errors && errors.province && onResetError && onResetError('province');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regPostalCode" error={errors && errors.postalCode}>
                            <label htmlFor="stateOrProvince">Zip/Postal Code</label>
                            <input
                                type="text"
                                className="form-control"
                                id="registoredZipOrPostalCode"
                                name='zipCode'
                                value={principalAddress.zipCode ? principalAddress.zipCode : ""}
                                onChange={(event) => {
                                    errors && errors.postalCode && onResetError && onResetError('postalCode');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regCountry" error={errors && errors.country}>
                            <label htmlFor="stateOrProvince">Country</label>
                            <input
                                type="text"
                                className="form-control"
                                id="country"
                                name='crcCountryId'
                                value={principalAddress.crcCountryId ? principalAddress.crcCountryId : ""}
                                onChange={(event) => {
                                    errors && errors.country && onResetError && onResetError('country');
                                    this.handleAddressChange(event, principalAddress);
                                }}
                            />
                        </FormField>
                    </div>
                    <div className="col-md-6">
                        <div className="section-title">
                            <span>Trading Address <span className='text-danger'>*</span></span>
                        </div>

                        <FormField className="form-group" id="regAddress" error={errors && errors.street}>
                            <label htmlFor="registeredAddressLin1">Address</label>
                            <input
                                className="form-control"
                                id="tradingAddressLine1"
                                name='streetAddressLine1'
                                onChange={(event) => {
                                    errors && errors.street && onResetError && onResetError('street');
                                    this.handleAddressChange(event, tradingAddress);
                                }}
                                type="text"
                                value={tradingAddress.streetAddressLine1 ? tradingAddress.streetAddressLine1 : ""}

                            />
                        </FormField>

                        <FormField className="form-group" id="line2" error={errors && errors.suburb}>
                            <label htmlFor="registeredAddressLine2">Suburb</label>
                            <input
                                className="form-control"
                                id="tradingAddressLine2"
                                name='suburb'
                                onChange={(event) => {
                                    errors && errors.suburb && onResetError && onResetError('suburb');
                                    this.handleAddressChange(event, tradingAddress);
                                }}
                                type="text"
                                value={tradingAddress.suburb ? tradingAddress.suburb : ""}
                            />
                        </FormField>

                        <FormField className="form-group" id="regCity" error={errors && errors.city}>
                            <label htmlFor="tradingCity">City</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tradingCity"
                                name='crcCityId'
                                value={tradingAddress.crcCityId ? tradingAddress.crcCityId : ""}
                                onChange={(event) => {
                                    errors && errors.city && onResetError && onResetError('city');
                                    this.handleAddressChange(event, tradingAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regProvince" error={errors && errors.province}>
                            <label htmlFor="stateOrProvince">State/Province</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tradingStateOrProvince"
                                name='crcRegionId'
                                value={tradingAddress.crcRegionId ? tradingAddress.crcRegionId : ""}
                                onChange={(event) => {
                                    errors && errors.province && onResetError && onResetError('province');
                                    this.handleAddressChange(event, tradingAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regPostalCode" error={errors && errors.postalCode}>
                            <label htmlFor="stateOrProvince">Zip/Postal Code</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tradingZipOrPostalCode"
                                name='zipCode'
                                value={tradingAddress.zipCode ? tradingAddress.zipCode : ""}
                                onChange={(event) => {
                                    errors && errors.postalCode && onResetError && onResetError('postalCode');
                                    this.handleAddressChange(event, tradingAddress);
                                }}
                            />
                        </FormField>

                        <FormField className="form-group" id="regCountry" error={errors && errors.country}>
                            <label htmlFor="stateOrProvince">Country</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tradingCountry"
                                name='crcCountryId'
                                value={tradingAddress.crcCountryId ? tradingAddress.crcCountryId : ""}
                                onChange={(event) => {
                                    errors && errors.country && onResetError && onResetError('country');
                                    this.handleAddressChange(event, tradingAddress)
                                }}
                            />
                        </FormField>
                    </div>


                </div>
        );
    }

    renderUpdater = () => {
        const {kyc: {kycRequest}} = this.props;
        if (kycRequest) {
            const wellStyles = {maxWidth: 400, margin: '0 auto 10px'};
            const shareholderDoc = this._findDoc(kycRequest.documents, 'Ownership Structure');
            const proofOfAuthDoc = this._findDoc(kycRequest.documents, 'Resolution');
            const proofOfLegalDoc = this._findDoc(kycRequest.documents, 'CIPC Document');
            return (
                <Col mdPush={1} md={10}>
                    <div className="col-md-12">
                        <h2>Entity Details</h2>
                        <hr/>
                        {this.renderEntityDetails()}
                    </div>
                    <div className="col-md-12">
                        <h2>Related Parties</h2>
                        <hr/>
                        <RelatedPartiesNew kycStructure={kycRequest}
                                           handleAddRelatedParty={this.handleAddRelatedParty}
                                           handleRelatedPartyAddressChange={this.handleRelatedPartyAddressChange}
                                           handleRelatedPartyChange={this.handleRelatedPartyChange}
                                           handleRemoveRelatedParty={this.handleRemoveRelatedParty}
                                           handleAddOwner={this.handleAddOwner}
                                           handleSave={this.onHandleSave}
                                           actions={this.props.actions}
                        />
                    </div>
                    <div className="col-md-12">
                        <h2>Authorised Persons</h2>
                        <hr/>
                        <AuthorisedPersonsComponent personsList={kycRequest.directors}
                                                    handleAddAuthorisedPerson={this.handleAddAuthorisedPerson}
                                                    onChange={this.handleDirectorChange}
                                                    handleRemoveAP={this.handleRemoveAP}
                                                    onAddressChange={this.handleDirectorAddressChange}
                                                    handleSave={this.onHandleSave}
                                                    actions={this.props.actions}
                        />
                    </div>
                    <AdditionalQuestions
                        onPipChange={this.handlePipChange}
                        onPipsUpdate={this.handlePipsUpdate}
                        onControlChange={this.handleControlChange}
                        onControllerUpdate={this.handleControlChange}
                    />
                    <div className="col-md-12">
                        <h2>Documents</h2>
                        <hr/>
                        <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="col-md-8">
                                        Ownership Structure
                                    </div>
                                    <div className="col-md-4">
                                        <button
                                            onClick={() => this.handleViewDocument(shareholderDoc)}
                                            disabled={shareholderDoc.verified}
                                            className={shareholderDoc.verified ? "btn btn-success" : "btn btn-primary"}
                                        >
                                            {shareholderDoc.verified ? "Verified" : "View/Update"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="col-md-8">
                                        CIPC Document
                                    </div>
                                    <div className="col-md-4">
                                        <button
                                            onClick={() => this.handleViewDocument(proofOfLegalDoc)}
                                            disabled={proofOfLegalDoc.verified}
                                            className={proofOfLegalDoc.verified ? "btn btn-success" : "btn btn-primary"}
                                        >
                                            {proofOfLegalDoc.verified ? "Verified" : "View/Update"}
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="col-md-8">
                                        Resolution
                                    </div>
                                    <div className="col-md-4">
                                        <button
                                            onClick={() => this.handleViewDocument(proofOfAuthDoc)}
                                            disabled={proofOfAuthDoc.verified}
                                            className={proofOfAuthDoc.verified ? "btn btn-success" : "btn btn-primary"}
                                        >
                                            {proofOfAuthDoc.verified ? "Verified" : "View/Update"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        {
                            this.state.validationErrors.map((error, i) => (
                                <Alert bsStyle="danger" key={i}>
                                    {error}
                                </Alert>
                            ))
                        }
                    </div>
                    <div className="col-md-12">
                        <div className="btn-group" style={wellStyles}>
                            <Button bsStyle="default" bsSize="large" onClick={this.onHandleSaveContinue}>
                                Save & Continue later
                            </Button>
                            <Button bsStyle="primary" bsSize="large" onClick={this.completeKYC}>
                                Submit Request
                            </Button>
                        </div>
                    </div>
                </Col>
            );
        }
    }


    render() {
        const {kyc} = this.props;
        const {selectedDocument} = this.state;
        return (
            <div className={'container-fluid'} style={{overflowY: 'auto'}}>
                <div className="col-xs-12">
                    {
                        this.renderUpdater()
                    }
                    {
                        kyc.saved && this.renderSaved()
                    }
                </div>
                {selectedDocument && (
                    <Popup onClose={() => this.setState({selectedDocument: null})}>
                        <DocumentViewer
                            fileId={selectedDocument.id} documentType={selectedDocument.type}
                            onUpload={this.onHandleUpload}
                            onRemove={this.onHandleRemoveDocument}
                            onVerify={() => this.onHandleVerify(selectedDocument)}
                        />
                    </Popup>
                )

                }
                <Modal show={this.state.submitting} onHide={() => this.setState({submitting: false})}>
                    <Modal.Header closeButton><h4>Contact Email Address</h4></Modal.Header>
                    <Modal.Body>
                        <h5>Provide a contact email address for us to contact should we need any more information:</h5>
                        {this.state.submittingError && <Alert bsStyle={'danger'}>{this.state.submittingError}</Alert>}
                        <input type={'email'} name={'contactEmail'} className={'form-control'}
                               id={'contact-email'} defaultValue={kyc.kycRequest.contactEmail}
                               onChange={this.handleEntityInfoChange}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonGroup>
                            <Button bsStyle={'primary'} onClick={this.submitReview}>Complete Review</Button>
                            <Button onClick={() => this.setState({submitting: false})}>Cancel</Button>
                        </ButtonGroup>
                    </Modal.Footer>
                </Modal>
            </div>
        );

    }
}


function mapStateToProps({kyc, impersonation, loading, individual}) {
    return {
        kyc,
        individual,
        impersonation: impersonation && impersonation.impersonation ? impersonation.impersonation : {},
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...entityActions,
            startKycMaintenance,
            uploadDoc,
            verifyDoc,
            onChangeValue,
            onDirChangeValue,
            setEntity,
            onNewDoc,
            saveKYC,
            onNewRelatedParty,
            onRemoveRelatedParty,
            onNewAuthorisedPerson,
            onRemoveAuthorisedPerson,
            kycSaved,
            onAddressChangeValue,
            addOwner,
            completeKYC,
            clearEntityInfo,
            removeSearched,
            clearIndiviualInfo,
            fetchIndiviualInfo,
            pip,
            updatePips,
            updateController
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(KycMaintenance);
